import { Suspense } from 'react';

import Layout from '@/Layout';
import Home from '@/page/home';

import { RouterGuard } from './RouteGuard';
import FlowHash from '@/page/flowHash';
import ContractHash from '@/page/contractHash';
import My from '@/page/my';
import LinkHash from '@/page/linkHash';
import tabHome from '@/image/tabHome.svg';
import tabFlowHash from '@/image/tabFlowHash.svg';
import tabContractHash from '@/image/tabContractHash.svg';
import tabMy from '@/image/tabMy.svg';
import tabLinkHash from '@/image/tabLinkHash.svg';
import Invitation from '@/page/invitation';
import LayoutAll from '@/Layout/footHeader';
import Invite from '@/page/invite';
import PowerPool from '@/page/powerPool';
import Grade from '@/page/grade';
import MyLink from '@/page/myLink';
import Information from '@/page/information';
import Bridge from '@/page/bridge';

export const routeConfig = [
  {
    path: "/",
    element: <Layout />,
    auth: true,
    children: [
      {
        path: "/",
        element: <LayoutAll />, // 邀请页面
        auth: true,
        children: [
          {
            path: "/",
            element: <Home />,   // tab 首页
            header: true, // 是否显示头部
            foot: true, // 是否显示底部
            icon: tabHome, // tab 图标
            footTitle: 'foot.homePage', // tab 标题
            headerTitle: 'foot.homePage', // 页面标题
            auth: true,
          },
          {
            path: "/flowHash",
            header: true, // 是否显示头部
            foot: true, // 是否显示底部
            element: <FlowHash />, // tab 流动算力
            footTitle: 'foot.flowHashrate', // tab 标题
            headerTitle: 'foot.flowHashrate', // 页面标题
            icon: tabFlowHash,
            auth: true,
          },
          {
            path: "/contractHash",
            element: <ContractHash />, // tab 合约算力
            header: true, // 是否显示头部
            foot: true, // 是否显示底部
            footTitle: 'foot.contractHashrate', // tab 标题
            headerTitle: 'foot.contractHashrate', // 页面标题
            icon: tabContractHash, // tab 图标
            auth: true,
          },
          {
            path: "/linkHash",
            element: <LinkHash />, // tab 链接算力
            header: true, // 是否显示头部
            foot: true, // 是否显示底部
            footTitle: 'foot.linkHashrate', // tab 标题
            headerTitle: 'foot.linkHashrate', // 页面标题
            icon: tabLinkHash,
            auth: true,
          },
          {
            path: "/my",
            element: <My />, // tab 我的
            header: true, // 是否显示头部
            foot: true, // 是否显示底部
            footTitle: 'foot.my', // tab 标题
            headerTitle: 'foot.my', // 页面标题
            icon: tabMy,
            auth: true,
          },
        ]
      },
      {
        path: "/invitation",
        element: <Invitation />, // 注册页面
        auth: false
      },
      {
        path: "/invite",
        element: <Invite />, // 邀请页面
        auth: true
      },
      {
        path: "/powerPool",
        element: <PowerPool />, // 矿池页面
        auth: true
      },
      {
        path: "/grade",
        element: <Grade />, // 等级页面
        auth: true
      },
      {
        path: "/myLink",
        element: <MyLink />, // 我的链接页面
        auth: true
      }, {
        path: "/information",
        element: <Information />, // 信息页面
        auth: true
      }, {
        path: "/bridge",
        element: <Bridge />, // 桥页面
        auth: true
      }

    ],
  },
];

const AppRouter = () => {
  const element = RouterGuard(routeConfig);
  return <Suspense> {element}</Suspense>;
};
export default AppRouter;
